'use strict';

angular.module('broadcastsModule')

.config(function ($provide)
{
    $provide.decorator('broadcastsViewOptions', function ($delegate, $state, kdGate)
    {
        const showGate = () => kdGate.allows('library.edit');

        $delegate.list.tableClass = 'table';
        $delegate.toolbar.map((button) => button.show = showGate);

        $delegate.actions.map((action) => {
            switch (action.name) {
                case 'edit':
                    action.show = (models) => {
                        return models.length === 1 && kdGate.allows('library.edit');
                    };

                    action.act = (models) =>
                    {
                        if (models[0].type && models[0].type === 'folder') {
                            $state.go('.edit-folder-thumb', {id: models[0].id});
                        } else {
                            $state.go('.edit', {id: models[0].id});
                        }
                    };
                    break;
                default:
                    action.show = (models) => {
                        return models.length >= 1 && kdGate.allows('library.edit');
                    };
            }
        });

        $delegate.onItemClick = function ($event, model)
        {
            $event.stopPropagation();

            if (model.type === 'folder') {
                $state.go('admin.broadcasters', {
                    folder_id: model.id,
                    offset: null,
                    name: null
                });
            } else {
                $state.go('admin.broadcasters.basket', {
                    id: model.id
                });
            }
        };

        $delegate.list.columns.splice(1, 0, {
            label: 'In basket',
            template: `<span ng-if="model.numInBasket">{{ model.numInBasket }}</span>`,
            sortable: false,
        });

        $delegate.list.columns.splice(3, 1, {
            label: 'Formats',
            template: `<span class="badge"
                             ng-if="::model.type !== 'folder'"
                             ng-repeat="format in model.format track by $index">{{ format }}</span>`,
            sortable: false,
        });

        $delegate.rowClassifier = (model, classes) => {
            classes[model.type] = true;
            return classes;
        };

        $delegate.grid.fields.push({
            template: `<span class="badge"
                             ng-show="model.numInBasket">
                         {{ model.numInBasket }}</span>
                       <span class="icon-folder"
                             ng-if="::model.type === 'folder'">
                         <i class="material-icon material-icon-folder-open"></i></span>
                       <span class="icon-asset"
                             ng-if="::model.type !== 'folder'">
                         <i class="material-icon material-icon-insert-drive-file"></i></span>`
        });

        return $delegate;
    });

});